module.exports = __webpack_public_path__ + "img/body-psychotherapy.cee0b24e.png";